import { BrowserRouter as Router, Switch } from 'react-router-dom';
import Backdrop from '../components/Backdrop';
import { useAuth } from '../contexts/auth';
import { QuizProvider } from '../contexts/quiz';
import FormForgotPassword from '../pages/Auth/ForgotPassword';
import H1N1 from '../pages/Auth/H1N1';
//#endregion
//#region RestrictedPages
import FormLogin from '../pages/Auth/Login';
import NewPassword from '../pages/Auth/NewPassword';
import Register from '../pages/Auth/Register';
import CheckIn from '../pages/CheckIn';
//#region PublicRoutes
import Error404 from '../pages/Error404';
import Fleets from '../pages/Fleets';
import CarDetails from '../pages/Fleets/CarDetails';
import CarsSelected from '../pages/Fleets/CarsSelected';
import OrderReceived from '../pages/Fleets/OrderReceived';
import FleetsQA from '../pages/Fleets/QA';
import MyHealth from '../pages/MyHealth';
import MyHealthQuiz from '../pages/MyHealthQuiz';
import MyHealthVaccine from '../pages/MyHealthVaccine';
import MySchedule from '../pages/MySchedule';
import NewAppointment from '../pages/NewAppointment';
import Notifications from '../pages/Notifications';
import Profile from '../pages/Profile';
import ReadTraining from '../pages/ReadTraining';
import Schedules from '../pages/Schedules';
import Trainings from '../pages/Trainings';
import PrivateContextRoute from './components/PrivateContextRoute';
import PrivateRoute from './components/privateRoute';
import PublicRoute from './components/publicRoute';

//#endregion

const Routes = () => {
  const { loading, isGPID } = useAuth();

  if (loading) return <Backdrop loading={loading} />;

  return (
    <Router>
      {!isGPID ? (
        <Switch>
          <PublicRoute restricted exact path="/" component={FormLogin} />
          <PublicRoute restricted exact path="/h1n1" gpid component={H1N1} />
          <PublicRoute
            restricted
            path="/esqueci-a-senha"
            component={FormForgotPassword}
          />
          <PublicRoute restricted path="/registro" component={Register} />
          <PublicRoute restricted path="/nova-senha" component={NewPassword} />
          <PrivateRoute path="/dashboard" component={Fleets} />
          <PrivateRoute path="/perfil" component={Profile} />
          <PrivateRoute path="/notificações" component={Notifications} />
          <PrivateRoute path="/agendamentos" component={Schedules} />
          <PrivateRoute path="/meu-agendamento/:id" component={MySchedule} />
          <PrivateRoute path="/novo-agendamento" component={NewAppointment} />
          <PrivateRoute path="/check-in/:id" component={CheckIn} />
          <PrivateRoute path="/minha-saude" exact component={MyHealth} />
          {/* <PrivateRoute path="/frotas" component={Fleets} /> */}
          <PrivateRoute path="/frotas/perguntas-frequentes" exact component={FleetsQA} />
          <PrivateRoute path="/frotas/descricao-veiculo/:id" exact component={CarDetails} />
          <PrivateRoute path="/frotas/veiculos-selecionados" exact component={CarsSelected} />
          <PrivateRoute path="/frotas/solicitacao-recebida" exact component={OrderReceived} />

          <PrivateRoute
            path="/minha-saude/vacina"
            exact
            component={MyHealthVaccine}
          />
          <PrivateContextRoute
            path="/minha-saude/quiz"
            component={MyHealthQuiz}
            contextProvider={QuizProvider}
          />
          <PrivateRoute path="/treinamentos" component={Trainings} />
          <PrivateRoute path="/treinamento/:id" component={ReadTraining} />
          <PublicRoute component={Error404} />
        </Switch>
      ) : (
        <Switch>
          <PublicRoute restricted exact path="/" component={FormLogin} />
          <PublicRoute restricted exact gpid path="/h1n1" component={H1N1} />
          <PublicRoute
            path="/esqueci-a-senha"
            component={FormForgotPassword}
            restricted
          />
          <PublicRoute restricted path="/registro" component={Register} />
          <PublicRoute restricted path="/nova-senha" component={NewPassword} />
          <PrivateRoute path="/perfil" component={Profile} />
          <PrivateRoute
            path="/minha-saude/vacina"
            component={MyHealthVaccine}
            exact
          />
          <PublicRoute component={Error404} />
        </Switch>
      )}
    </Router>
  );
};
export default Routes;
